import type { FaireProductEntity } from "../../entity_types/product";

export const p_pgm62pczym: FaireProductEntity = {
  token: "p_pgm62pczym",
  type: "product",
  name: "Magnesium, Zinc & D3 Capsules",
  brandToken: "b_5071j6eb6g",
  brandName: "NutraChamps",
  imageUrl:
    "https://cdn.faire.com/fastly/1085ab6198bd134a24cf666dcd78341638d2b89852d775d2c7328fd1719cbce0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aee7dc9640e583b94b2e4f6f91609d25f5e40b3fca8444d8cc4858e1c1a25272.jpeg",
    "https://cdn.faire.com/fastly/4f8c43e40fbc01ce3a16dadbff748f21a53564cae84b75c275db31f03461d71d.jpeg",
    "https://cdn.faire.com/fastly/8fcd49957871a21c8df493d771b2cc3d006cdb0584c28d06c95417ad03903b9c.jpeg",
    "https://cdn.faire.com/fastly/4667f9c6f8dc30d54278e2de6691ae720c17505aa6bde91d8b989c1f4c0cc6cb.jpeg",
    "https://cdn.faire.com/fastly/2b59d888d3e879832a8c304bb89ba54c4d0940f01e85a962ffcadf71bc11fe5e.jpeg",
    "https://cdn.faire.com/fastly/0dc2581cb7d6a190ee82c4da4769b93009d529c2ea7b3488fce0ccaa3e78d89e.jpeg",
  ],
  priceDollars: 16.59,
  description:
    "Better magnesium, high absorption formula - each serving provides a full 225 mg of pure elemental magnesium, just like nature intended. Open wide for your daily dose of magnesium citrate, magnesium malate and magnesium glycinate - the most bioavailable forms of this key mineral. Also included are high absorption zinc gluconate and picolinate for extra benefits.\nIncludes zinc & vegan vitamin d3 - magnesium and zinc are cofactors for vitamin d, and all three are essential components for hundreds of enzymatic processes. With nearly half of all americans suffering from either magnesium, zinc or vit d3 deficiency, getting enough of these nutrients is absolutely essential for a healthy lifestyle.",
  tags: [],
  msrpDollars: 27.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:59.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
